import DOMPurify from "dompurify";

const ALLOWED_TAGS = [
  "p", "br", "strong", "em", "s", "ul", "ol", "li", "blockquote", "code", "pre", "a", "span",
  "img", "figure", "figcaption", "button", "svg", "path",
];
const ALLOWED_ATTR = [
  "href", "target", "rel", "class", "data-type", "data-id", "data-label",
  "src", "alt", "loading", "data-attachment-id", "type", "aria-label", "title",
  "width", "height", "viewBox", "fill", "stroke", "stroke-width", "stroke-linecap",
  "stroke-linejoin", "d", "xmlns",
];

/** Sanitize persisted chat markup at the render boundary. */
export function sanitizeMessageHtml(html: string): string {
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOW_DATA_ATTR: true,
  });
}
